import { render, staticRenderFns } from "./Echarts2.vue?vue&type=template&id=1d62b4dc&"
import script from "./Echarts2.vue?vue&type=script&lang=js&"
export * from "./Echarts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports